<div class="bulk-action-dialog">
  <portal-bulk-action-dialog-header
    [header]="defaultHeader"
    [variant]="variant"
    (dismiss)="close()"
  ></portal-bulk-action-dialog-header>

  <ng-template #defaultHeader>{{ title | portalTranslate }}</ng-template>

  <portal-modal-body class="g-min-height-100px">
    <portal-loading-indicator-container [loading]="loading">
      <!-- component instance -->
      <div #handlerHost [hidden]="configurationError != null"></div>

      <portal-bulk-action-entries
        #list
        [availabilityChanged]="handlerComponent.instance.availabilityChanged"
        [checkAvailability]="handlerComponent.instance.checkAvailability"
        [entries]="entries"
        [entryTemplate]="isTemplateRef(body) ? $any(body) : defaultBody"
        [hidden]="configurationError != null"
        [label]="label"
        [messages]="handlerComponent.instance.availabilityMessages"
        [process]="handlerComponent.instance.process"
        [processInParallel]="processInParallel"
        (submitted)="onSubmitted($event)"
        (submitting)="onSubmitting()"
      >
      </portal-bulk-action-entries>

      <ng-template #defaultBody let-entry="entry">{{ $any(body)(entry) }}</ng-template>

      @if (configurationError != null) {
        <portal-errors [dismissible]="false" [errors]="configurationError">
          <ng-template portalTransclude="title">
            {{ 'bulk.action.couldNotLoadConfigData' | translate }}
          </ng-template>
        </portal-errors>
      }

      @if (result?.errors != null) {
        <portal-errors class="d-block mt-3" [dismissible]="false" [errors]="result.errors"> </portal-errors>
      }
    </portal-loading-indicator-container>
  </portal-modal-body>

  <div class="modal-footer">
    <portal-bulk-action-dialog-footer
      [actionLabel]="actionLabel"
      [disabled]="list.noEntryAvailable"
      [invalid]="invalid"
      [pending]="pending"
      [result]="result"
      [variant]="variant"
      (close)="close()"
      (dismiss)="close()"
      (submit)="list.submit()"
    ></portal-bulk-action-dialog-footer>
  </div>
</div>
